import React, { useState } from 'react'
import { Card, Col, Flex, Form, Row, Typography } from 'antd'
import {ModuleTopHeading, Projecttable, SearchInput, Transactiontable } from '../../components';

const { Text } = Typography
const Transaction = () => {

    const [ visible, setVisible] = useState(false)
    const [ edititem, setEditItem ] = useState(null)
    const [form] = Form.useForm();
   
    return (
        <>
            <Card className='shadow-d radius-12'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex vertical gap={20}>
                            <ModuleTopHeading level={4} name='Transaction History'/>
                        </Flex>
                    </Col>
                    <Col span={24}>
                       <Transactiontable {...{setEditItem,setVisible}} />
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export { Transaction }
